export default "__VITE_ASSET__BPoGvBwJ__"